import { getPeritaje } from './getPeritaje'
import { getPeritajeForPresupuestador } from './getPeritajeForPresupuestador'
import { getPeritajeForGO } from './getPeritajeForGO'
import { putRecepcionManual } from './putRecepcionManual'
import { getAllVAttributesByVerificationID } from './getAllVAttributesByVerificationID'
import { getRequest } from './getRequest'
import { getVerificationPdf } from './getVerificationPdf'
import { getBusinessUnits } from './getBusinessUnits'
import { getFiles } from './getFiles'
import { getOriginChannels } from './getOriginChannels'
import { getCarmuvRequirements } from './getCarmuvRequirements'
import { getTabs } from './getTabs'
import { getLockedPatent } from './getLockedPatent'
import { postDirectPurchaseUsed } from 'BFF/BFF_peritador/postDirectPurchaseUsed'

export const Peritador = {
  getPeritaje,
  getPeritajeForPresupuestador,
  getPeritajeForGO,
  putRecepcionManual,
  getAllVAttributesByVerificationID,
  getRequest,
  getBusinessUnits,
  getVerificationPdf,
  getFiles,
  getOriginChannels,
  getCarmuvRequirements,
  getTabs,
  getLockedPatent,
  postDirectPurchaseUsed
}
